module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/X5olBw/tc-custom/9781449498665.jpg?1737680567233",
      "alt": "This image is the cover for the book Crown Anthology, Lost Poets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crown Anthology, Lost Poets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Two hundred poems of hope and empowerment in a time of tumult and darkness, from Instagram’s Lost Poets community. ")]), _c('br'), _c('br'), _c('i', [_vm._v("Crown Anthology ")]), _vm._v("is a new collection of verse from an online subculture of poets, with a foreword by Tyler Knott Gregson, one of the movement’s foremost authors. By celebrating self-love, self-worth, and empowerment, these two hundred poems examine life in a dynamic and transformative poetry compilation that speaks soft words reminding us that every soul is royal. "), _c('br'), _c('br'), _vm._v("Featuring a beautifully diverse and inspirational set of voices from around the world, which includes some of today’s most influential modern poets with additional contest winners chosen from 4,500 submissions, "), _c('i', [_vm._v("Crown Anthology")]), _vm._v(" is curated to be a light in the wild dark, illuminating the crown that exists in everyone.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Analog de Lèon, Gabriel Sage\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0